import React, { useState } from 'react'
import { Link } from 'react-router-dom'

const DownloadComponent = ({ the_id, percentValue }) => {

    let downloadableExcelLink = ""

    if (the_id === 0) {
        downloadableExcelLink = "https://niroggyan.s3.ap-south-1.amazonaws.com/corporate-dashboard-excel-files/blood_counts.xlsx"
    }

    else if (the_id === 1) {
        downloadableExcelLink = "https://niroggyan.s3.ap-south-1.amazonaws.com/corporate-dashboard-excel-files/diabetes_monitoring.xlsx"
    }

    else if (the_id === 2) {
        downloadableExcelLink = ""
    }

    else if (the_id === 3) {
        downloadableExcelLink = "https://niroggyan.s3.ap-south-1.amazonaws.com/corporate-dashboard-excel-files/lipid_profile.xlsx"
    }

    else if (the_id === 4) {
        downloadableExcelLink = "https://niroggyan.s3.ap-south-1.amazonaws.com/corporate-dashboard-excel-files/liver_profile.xlsx"
    }

    else if (the_id === 5) {
        downloadableExcelLink = "https://niroggyan.s3.ap-south-1.amazonaws.com/corporate-dashboard-excel-files/bmi_bp2.xlsx"
    }

    else if (the_id === 6) {
        downloadableExcelLink = "https://niroggyan.s3.ap-south-1.amazonaws.com/corporate-dashboard-excel-files/electrolyte_profile.xlsx"
    }

    else if (the_id === 7) {
        downloadableExcelLink = "https://niroggyan.s3.ap-south-1.amazonaws.com/corporate-dashboard-excel-files/urinalysis_profile.xlsx"
    }

    return (
        <div>

            {downloadableExcelLink === "" ?
                <i
                    title="no abnormal tests"
                    className="fas far fa-file-excel download-file-disable-css">
                </i>
                :
                <a
                    href={downloadableExcelLink}
                    target='_blank'
                    download
                >
                    <i
                        title="get abnormal tests data"
                        className="fas far fa-file-excel download-file-css">
                    </i>
                </a>
            }
        </div>
    )
}

export default DownloadComponent